import React from 'react';
import styled from 'styled-components';

const StyledFeatureButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  border: 1px solid var(--color-button-accent);
  border-radius: 4px;
  color: var(--color-button-accent);
  font-weight: var(--font-weight-body-1);
  cursor: pointer;
  text-align: center;
  width: ${({ fullwidth }) => (fullwidth === "true" ? "100%" : "unset")};

  &:hover {
    background-color: var(--color-button-accent);
    color: var(--color-container-card-default);
  }

  @media(max-width: 768px){
  font-size: 12px;
  padding: 4px 16px;
  }
`;

const PlusSpan = styled.span`
  margin-left: 8px;
`;

const FeatureButton = ({ buttonText, action, hidePlus, fullwidth }) => {
  return (
    <StyledFeatureButton onClick={action} fullwidth={fullwidth + ""}>
      {buttonText} {!hidePlus && <PlusSpan>+</PlusSpan>}
    </StyledFeatureButton>
  );
};

export default FeatureButton;
